import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  wrapper: {
    minHeight: 200,
  },
  summaryContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    border: `1px solid #ABAFB3`,
    borderRadius: theme.spacing(10),
    padding: theme.spacing(10, 10, 15),
    marginBottom: 20,
    fontSize: 18,
  },
  spinnerWrapper: {
    height: '100%',
    transform: 'translateY(100%)',
  },
  refundAmountLabel: {
    fontSize: 20,
    fontWeight: 500,
  },
  refundAmountValue: {
    display: 'block',
    paddingTop: 10,
    borderTop: '1px solid #CFCED3',
    fontSize: 20,
    fontWeight: 500,
  },
}));
